export default __webpack_public_path__ + "static/media/button_point-on.0966b8e4.svg";